import Vue from 'vue';
import moment from 'moment';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'

export const LOAD_PROJECT_FINANCES = 'LOAD_PROJECT_FINANCES';
export const LOAD_SINGLE_PROJECT_INDEPTH_DATA = 'LOAD_SINGLE_PROJECT_INDEPTH_DATA';
export const SET_PROJECT_FINANCES = 'SET_PROJECT_FINANCES';

export const LOAD_PROJECT_INDEPTH_DATA = 'LOAD_PROJECT_INDEPTH_DATA';
export const SET_PROJECT_INDEPTH = 'SET_PROJECT_INDEPTH';

const state = {
  actuals: {},
  materials: {},
  etc: {},
  labourCostsYearweek: [],
  labourCosts: [],
  plannedLabourCostsYearweek: [],
  plannedLabourCosts: [],
  materialCosts: [],
};

const getters = {
  actuals: (state) => {
    return state.actuals;
  },
  materials: (state) => {
    return state.materials;
  },
  etc: (state) => {
    return state.etc;
  },
  labourCostsByProjectByYearweek: (state) => {
    const labourCosts = {};
    for (var yearweek in state.labourCostsYearweek) {
      state.labourCostsYearweek[yearweek].forEach((labourCost) => {
        labourCosts[labourCost.id] = labourCosts[labourCost.id] || {};
        labourCosts[labourCost.id][yearweek] = labourCosts[labourCost.id][yearweek] || 0;
        labourCosts[labourCost.id][yearweek] += parseFloat(labourCost.cost);
      });
    }
    return labourCosts;
  },
  labourCostsByProjectByMonth: (state) => {
    const labourCosts = {};
    state.labourCosts.forEach((labourCost) => {
      const month = `${labourCost.year}${labourCost.month}`;
      labourCosts[labourCost.id] = labourCosts[labourCost.id] || {};
      labourCosts[labourCost.id][month] = labourCosts[labourCost.id][month] || 0;
      labourCosts[labourCost.id][month] += parseFloat(labourCost.cost);
    });
    return labourCosts;
  },
  plannedLabourCostsByProjectByYearweek: (state) => {
    const plannedLabourCosts = {};
    for (var yearweek in state.plannedLabourCostsYearweek) {
      state.plannedLabourCostsYearweek[yearweek].forEach((labourCost) => {
        plannedLabourCosts[labourCost.id] = plannedLabourCosts[labourCost.id] || {};
        plannedLabourCosts[labourCost.id][yearweek] = plannedLabourCosts[labourCost.id][yearweek] || 0;
        plannedLabourCosts[labourCost.id][yearweek] += parseFloat(labourCost.cost);
      });
    }
    return plannedLabourCosts;
  },
  plannedLabourCostsByProjectByMonthAfterToday: (state) => {
    const plannedLabourCosts = {};
    state.plannedLabourCosts.forEach((labourCost) => {
      if (new Date(labourCost.date) > new Date()) {
        const month = `${labourCost.year}${labourCost.month}`;
        plannedLabourCosts[labourCost.id] = plannedLabourCosts[labourCost.id] || {};
        plannedLabourCosts[labourCost.id][month] = plannedLabourCosts[labourCost.id][month] || 0;
        plannedLabourCosts[labourCost.id][month] += parseFloat(labourCost.cost);
      }
    });
    return plannedLabourCosts;
  },
  labourCostsByYearweek: (state) => {
    const labourCosts = {};
    for (var yearweek in state.labourCostsYearweek) {
      labourCosts[yearweek] = labourCosts[yearweek] || 0;
      state.labourCostsYearweek[yearweek].forEach((labourCost) => {
        labourCosts[yearweek] += parseFloat(labourCost.cost);
      });
    }
    return labourCosts;
  },
  plannedLabourCostsByYearweek: (state) => {
    const plannedLabourCosts = {};
    for (var yearweek in state.plannedLabourCostsYearweek) {
      plannedLabourCosts[yearweek] = plannedLabourCosts[yearweek] || 0;
      state.plannedLabourCostsYearweek[yearweek].forEach((labourCost) => {
        plannedLabourCosts[yearweek] += parseFloat(labourCost.cost);
      });
    }
    return plannedLabourCosts;
  },
  materialCostsByProjectByYearweek: (state) => {
    const materialCosts = {};
    for (let i = 0; i < state.materialCosts.length; i++) {
      const materialCost = state.materialCosts[i];
      const yearweek = materialCost.yearweek;
      materialCosts[materialCost.project_id] = materialCosts[materialCost.project_id] || {};
      materialCosts[materialCost.project_id][yearweek] = materialCosts[materialCost.project_id][yearweek] || 0;
      materialCosts[materialCost.project_id][yearweek] += parseFloat(materialCost.cost);
    }
    return materialCosts;
  },
  materialCostsByProjectByMonth: (state) => {
    const materialCosts = {};
    for (let i = 0; i < state.materialCosts.length; i++) {
      const materialCost = state.materialCosts[i];
      const month = `${materialCost.year}${materialCost.month}`;
      materialCosts[materialCost.project_id] = materialCosts[materialCost.project_id] || {};
      materialCosts[materialCost.project_id][month] = materialCosts[materialCost.project_id][month] || 0;
      materialCosts[materialCost.project_id][month] += parseFloat(materialCost.cost);
    }
    return materialCosts;
  },
  materialCostsByYearweek: (state) => {
    const materialCosts = {};
    for (let i = 0; i < state.materialCosts.length; i++) {
      const materialCost = state.materialCosts[i];
      const yearweek = materialCost.yearweek;
      materialCosts[yearweek] = materialCosts[yearweek] || 0;
      materialCosts[yearweek] += parseFloat(materialCost.cost);
    }
    return materialCosts;
  },
};

const actions = {
  [LOAD_PROJECT_FINANCES]: function ({ commit }) {
    Backend.get('/api/project-finances').then((response) => {
      const actuals = {};
      const materials = {};
      const etc = {};
      response.data.actuals.forEach((project) => {
        actuals[project.id] = parseInt(project.actuals);
      });
      response.data.materials.forEach((material) => {
        materials[material.id] = material;
      });
      response.data.etc.forEach((project) => {
        etc[project.id] = parseInt(project.etc) / 100;
      });
      commit('SET_PROJECT_FINANCES', { actuals: actuals, materials: materials, etc: etc });
    });
  },
  [LOAD_PROJECT_INDEPTH_DATA]: function ({ commit }) {
    Backend.get('/api/project_indepth', { params: {} }).then((response) => {
      const labourCostsYearweek = {};
      const plannedLabourCosts = {};
      const materialCosts = {};
      for (var i = 0; i < response.data.labourCosts.length; i++) {
        var labourCost = response.data.labourCosts[i];
        labourCostsYearweek[labourCost.yearweek] = labourCostsYearweek[labourCost.yearweek] || [];
        labourCostsYearweek[labourCost.yearweek].push(labourCost);
      }

      for (var i = 0; i < response.data.plannedLabourCosts.length; i++) {
        var labourCost = response.data.plannedLabourCosts[i];
        plannedLabourCosts[labourCost.yearweek] = plannedLabourCosts[labourCost.yearweek] || [];
        plannedLabourCosts[labourCost.yearweek].push(labourCost);
      }

      commit('SET_PROJECT_INDEPTH', { response: response, labourCostsYearweek: labourCostsYearweek, plannedLabourCostsYearweek: plannedLabourCosts, labourCosts: response.data.labourCosts, plannedLabourCosts: response.data.plannedLabourCosts });
    });
  },
  [LOAD_SINGLE_PROJECT_INDEPTH_DATA]: function ({ commit }, { id }) {
    Backend.get('/api/single-project_indepth', { params: { project_id: id } }).then((response) => {
      const labourCostsYearweek = {};
      const plannedLabourCosts = {};
      const materialCosts = {};
      for (var i = 0; i < response.data.labourCosts.length; i++) {
        var labourCost = response.data.labourCosts[i];
        labourCostsYearweek[labourCost.yearweek] = labourCostsYearweek[labourCost.yearweek] || [];
        labourCostsYearweek[labourCost.yearweek].push(labourCost);
      }

      for (var i = 0; i < response.data.plannedLabourCosts.length; i++) {
        var labourCost = response.data.plannedLabourCosts[i];
        plannedLabourCosts[labourCost.yearweek] = plannedLabourCosts[labourCost.yearweek] || [];
        plannedLabourCosts[labourCost.yearweek].push(labourCost);
      }

      commit('SET_PROJECT_INDEPTH', { response: response, labourCostsYearweek: labourCostsYearweek, plannedLabourCostsYearweek: plannedLabourCosts, labourCosts: response.data.labourCosts, plannedLabourCosts: response.data.plannedLabourCosts });
    });
  }
};

const mutations = {
  [SET_PROJECT_FINANCES]: function (state, { actuals, materials, etc }) {
    state.actuals = actuals;
    state.materials = materials;
    state.etc = etc;
  },
  [SET_PROJECT_INDEPTH]: function (state, { response, plannedLabourCostsYearweek, labourCostsYearweek, labourCosts, plannedLabourCosts }) {
    Vue.set(state, 'labourCostsYearweek', labourCostsYearweek);
    Vue.set(state, 'plannedLabourCostsYearweek', plannedLabourCostsYearweek);
    Vue.set(state, 'materialCosts', response.data.materialCosts);
    Vue.set(state, 'labourCosts', labourCosts);
    Vue.set(state, 'plannedLabourCosts', plannedLabourCosts);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
